/* eslint-disable */

import * as runtime from '../runtime';
import type {
  OrgForSessionDto,
} from '../models';

export interface GetOrgForAnonSessionRequest {
  orgId?: number;
  host?: string;
  orgSlug?: string;
}

export class DashboardApi extends runtime.BaseAPI {

  async getOrgForAnonSession(requestParameters: GetOrgForAnonSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgForSessionDto> {
    const queryParameters: any = {};

    if (requestParameters.orgId !== undefined) {
      queryParameters['orgId'] = requestParameters.orgId;
    }

    if (requestParameters.host !== undefined) {
      queryParameters['host'] = requestParameters.host;
    }

    if (requestParameters.orgSlug !== undefined) {
      queryParameters['orgSlug'] = requestParameters.orgSlug;
    }

    const response = await this.request({
      path: '/dashboard/session-org-anon',
      method: 'GET',
      headers: {},
      query: queryParameters,
    }, initOverrides);
    return response.json();
  }

}
